import React, { Suspense, useCallback } from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Skeleton, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';
import { useDrawerContext } from './DrawerContext';

const DeliveryZipCode = React.lazy(() => import(
  /* webpackChunkName: "DeliveryZipCode" */
  '@thd-olt-component-react/delivery-zip-code')
  .then(module => ({ default: module.DeliveryZipCode }))
// eslint-disable-next-line no-console
  .catch((error) => console.warn(`Error occurred while lazy loading delivery zip code - ${error}`)));

const DeliveryZipCodeContent = () => {
  const { drawerState, drawerDispatch } = useDrawerContext();
  const { isUpdating } = drawerState;
  const setIsUpdating = useCallback((payload) => {
    drawerDispatch({ type: 'SET_IS_UPDATING', payload });
  }, [drawerDispatch]);
  return (
    <ErrorBoundary id="header-delivery-zip-code" name="header-delivery-zip-code">
      <Suspense fallback={(
        <div className="sui-grid">
          <Skeleton grow>
            <SkeletonLine variant="single" />
          </Skeleton>
          <Skeleton grow>
            <SkeletonLine variant="single" />
            <SkeletonBlock aspect="wide" height={12} />
          </Skeleton>
          <Skeleton grow>
            <SkeletonLine variant="single" />
            <SkeletonBlock aspect="wide" height={12} />
          </Skeleton>
        </div>
      )}
      >
        <DeliveryZipCode isUpdating={isUpdating} setIsUpdating={setIsUpdating} />
      </Suspense>
    </ErrorBoundary>
  );
};

DeliveryZipCodeContent.displayName = 'DeliveryZipCodeContent';

export default DeliveryZipCodeContent;